import { BCDataGrid } from '@bimser/components';
import { mobile } from '@bimser/core';
import IconCancel from '@bimser/icons/16/cancel';
import IconDelete from '@bimser/icons/16/delete';
import IconEdit from '@bimser/icons/16/edit';
import IconOk from '@bimser/icons/16/ok';
import DataGrid2 from '../..';

export const generateButtonsColumn = (dataGrid: DataGrid2) => {
	const isReadOnly = dataGrid.__isReadOnly();

	return (
		<BCDataGrid.Components.Column
			type="buttons"
			fixed={!dataGrid.columnHidingEnabled}
			fixedPosition="left"
			width={mobile().any() ? 100 : undefined}
		>
			{!isReadOnly && dataGrid.editing.showEditCommand && (
				<BCDataGrid.Components.ColumnButton
					icon={IconEdit.info.getElement()}
					cssClass="dx-link"
					name="edit"
					key="edit"
				/>
			)}

			{!isReadOnly && dataGrid.editing.showDeleteCommand && (
				<BCDataGrid.Components.ColumnButton
					icon={IconDelete.info.getElement()}
					cssClass="dx-link"
					name="delete"
					key="delete"
				/>
			)}
			{!isReadOnly && (
				<BCDataGrid.Components.ColumnButton
					icon={IconOk.info.getElement()}
					cssClass="dx-link"
					name="save"
					key="save"
				/>
			)}
			{!isReadOnly && (
				<BCDataGrid.Components.ColumnButton
					icon={IconCancel.info.getElement()}
					cssClass="dx-link"
					name="cancel"
					key="cancel"
				/>
			)}
			{!isReadOnly && (
				<BCDataGrid.Components.ColumnButton
					icon={IconCancel.info.getElement()}
					cssClass="dx-link"
					name="undelete"
					key="undelete"
				/>
			)}
		</BCDataGrid.Components.Column>
	);
};
